import { getAuthenticatedHeader } from "../../helpers/index";

export const networkOptions = {
    ...getAuthenticatedHeader
}